export default __webpack_public_path__ + "static/publicsector-circle-107968ea01e6911f3f7d1d947b74760b.png";